module.exports = __webpack_public_path__ + "static/media/logo.1189db98.svg";